import { Component, Input } from '@angular/core';
import { ISeoControl } from '@interfaces';
import { RestUrlService, TypeUrl } from 'src/app/core/services/api.services/settings/rest-url.service';

@Component({
  selector: 'bz-instruction-author',
  templateUrl: './bz-instruction-author.component.html',
  styleUrls: ['./bz-instruction-author.component.sass']
})
export class BzInstructionAuthorComponent {
  @Input() public seoControl: ISeoControl | null = null;
  @Input() public addExtraMarginBottom: boolean = false;
  @Input() public showLeftSide: boolean = true;
  @Input() public showRightSide: boolean = true;

  readonly photoImages: string;

  constructor(
    private readonly restUrlService: RestUrlService,
  ) {
    this.photoImages = this.restUrlService.getUrl(TypeUrl.img) + '/216-216/';
  }
}
